import storage from 'app/common/lib/Storage';

function getJSONDataMap(storageItems) {
  const dataMap = {};

  storageItems.forEach((itemKey) => {
    const currentStorageItem = storage.localStorage.getItem(itemKey);
    if (currentStorageItem) {
      if (itemKey === PCONST.LOCALSTORAGE_SIGNUP_INTERESTS_PICKER_START_TIME) {
        dataMap.signupInterestsPickerTimeSpent = Date.now() - currentStorageItem;
      } else {
        dataMap[itemKey] = currentStorageItem;
      }
    }
  });

  return JSON.stringify(dataMap);
}

export default function getUserAuthBehaviorDataMap() {
  const storageItems = [
    PCONST.LOCALSTORAGE_SIGNUP_INTERESTS_PICKER_SCROLL_DOWN,
    PCONST.LOCALSTORAGE_SIGNUP_INTERESTS_PICKER_START_TIME,
  ];
  return getJSONDataMap(storageItems);
}

export function getUserUnauthBehaviorDataMap() {
  const storageItems = [
    PCONST.LOCALSTORAGE_SIGNUP_TRIED_SKIP_INPUT_NAME,
    PCONST.LOCALSTORAGE_SIGNUP_TRIED_SKIP_GENDER,
    PCONST.LOCALSTORAGE_UNAUTH_TOPICS_FOLLOWED,
  ];
  return getJSONDataMap(storageItems);
}
